import React from "react";
import Layout from "../Layout";
import HeaderUser from "./HeaderUser";
import ListUser from "./ListUser";
import AddEmail from "../shared/AddEmail";
import SearchUser from "./SearchUser";
import TwoFactor from "./TwoFactor";
import TwoFactorPreReg from "./TwoFactorPreReg";

const Users = () => (
  <Layout>
    <HeaderUser />
    <ListUser />
    <AddEmail />
    <SearchUser />
    <TwoFactor />
    <TwoFactorPreReg />
  </Layout>
);

export default Users;
